import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ToastController, ViewController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the WithdrawalconfirmPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-withdrawalconfirm',
  templateUrl: 'withdrawalconfirm.html',
})
export class WithdrawalconfirmPage {

    loginId: string;
	api_key: string;
	email: string;
	version: string;
	
    target_coin: string;
    bank: string;
    bank_name: string;
    account_number: string;
    account_holder: string;
    address: string;
    balance: string;
    value: string;
    amount: string;
    fee: string;
    // donation: string;
    coin: string;
    remain: string;
    idx: string;

    coin_unit: string;
    bonus_unit: string;
    token_unit: string;
    unit: string;
    
    texts: any = [];
	language : string;

    isSend : boolean = true;
    isToken : boolean = false;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
        public viewCtrl: ViewController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
		public app: App
    ) {
        // this.bank = this.navParams.get('bank');
        // this.account_number = this.navParams.get('account_number');
        // this.account_holder = this.navParams.get('account_holder');
        this.target_coin = this.navParams.get('target_coin');
        this.value = this.navParams.get('value');
        this.address = this.navParams.get('address');

        this.bank = this.navParams.get('bank');
        // this.account_number = this.navParams.get('account_number');
        // this.account_holder = this.navParams.get('account_holder');
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "withdrawalcoin");
        this.language = localStorage.getItem("language");
        this.email = localStorage.getItem("email");
        this.version = localStorage.getItem("version");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.token_unit = localStorage.getItem("token_unit");
        this.unit = localStorage.getItem("unit");
        
        setTimeout(() => {
			if (this.bank == undefined) {
                this._init_coin();
            } else  {
                this._init_point();
            }
		},500);
        
        if (this.target_coin == 'token') {
            this.isToken = true; 
            // this.coin_unit = this.token_unit;
        }
        
        this._get_texts();       

	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).withdrawalconfirm;
	}

    _send_point() {
        let url = "withdraw/point/index/save";
        let send_data = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            bank: this.bank,
            account_number: this.account_number,
            account_holder: this.account_holder,
            value: this.amount,
            fee: this.fee,
            // donation: this.donation,
            idx: this.idx,
            
        });
        this.http.post(url, send_data).then((res: any) => {
            if (res.result == "OK") {
                this._close('ok');

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
                this.isSend = true;
            
            } else {
                let alert = this.alertCtrl.create({
                    // title: '<span class="fail"> Fail </span>',
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this.isSend = true;
            }
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
            this.isSend = true;
        });
    }

    _send_coin() {
        let url
        if (this.isToken) {
            url = "withdraw/binance/token/save";
        } else {
            url = "withdraw/binance/index/save";
        }
        let send_data = JSON.stringify({ 
            api: this.api_key,
            language: this.language,
            version: this.version,
            // bank: this.bank,
            // account_number: this.account_number,
            // account_holder: this.account_holder,
            address: this.address,
            value: this.amount,
            fee: this.fee,
            // donation: this.donation,
            coin: this.coin,
            idx: this.idx,
            
        });
        this.http.post(url, send_data).then((res: any) => {
            if (res.result == "OK") {
                // this._close('ok');
                if (this.isToken) {
                    this._close('token');
                } else {
                    this._close('coin');
                }

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
                this.isSend = true;
            
            } else {
                let alert = this.alertCtrl.create({
                    // title: '<span class="fail"> Fail </span>',
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this.isSend = true;
            }
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
            this.isSend = true;
        });
    }

    _init_point() {
		//// 서버로부터의 데이타
        let url = "withdraw/point/index/confirm";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
            value: this.value,
            bank: this.bank,
            account_holder: this.account_holder,
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.bank = res.bank;
                this.bank_name = res.bank_name;
                this.amount = res.value;
                this.fee = res.fee;
                this.remain = res.remain;
                this.idx = res.idx;
                

			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}
	
	_init_coin() {
		//// 서버로부터의 데이타
        let url
        if (this.isToken) {
            url = "withdraw/binance/token/confirm";
        } else {
            url = "withdraw/binance/index/confirm";
        }
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
            value: this.value,
            // bank: this.bank,
            // account_holder: this.account_holder,
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                // this.bank = res.bank;
                // this.bank_name = res.bank_name;
                this.balance = res.balance;
                this.coin_unit = res.coin_unit;
                this.bonus_unit = res.bonus_unit;
                this.amount = res.value;
                this.fee = res.fee;
                // this.donation = res.donation;
                this.coin = res.coin;
                this.remain = res.remain;
                this.idx = res.idx;
                

			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this._close('');

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this._close('');
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                this._close('');
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
			
		},(err)=>{
            this._close('');
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		
		});
	}
	
	_close(data) {
        this.viewCtrl.dismiss(data);
    }
}


// WEBPACK FOOTER //
// ./src/pages/withdrawalconfirm/withdrawalconfirm.ts